<template>
    <div :class="{'resourceTiles': direction == 'horizontal', 'resourceTilesVertical': direction == 'vertical'}">
        <div class='resourceTile ' v-for='(image, index) in gallery' :key='image.id' >
            <div class='resourceTileInner' :class='color' v-if='image.image.type == "Image"' @click='selectImage(index)'>
                <img :src='image.thumbnail.url' >
                <div class='resourceText'><h2>{{image.title}}</h2></div>
            </div>    
            <div v-else class='cs-cerulean resourceTileInner' @click='selectImage(index)'>
                <img v-if='image.thumbnail == null' class='resourceImage' :src="require('../assets/pdf_thumbnail.png').default">
                <img v-else class='resourceImage' :src='image.thumbnail.url'>
                <div class='resourceText'><h2>{{image.title}}</h2></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'gallery-thumbnails',
    props: ['gallery', 'color', 'direction'],
    methods: {
        selectImage(index) {
            this.$emit('selectImage', index);
        }
    }
}
</script>